// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 884 ? "admin" : chunkId) + "." + {"76":"44b59cfb","129":"adf7c58f","436":"23c6f616","453":"7bcc0666","566":"5a61ac5d","884":"317d8e79","954":"ba7817ac","971":"2d0376b4"}[chunkId] + ".chunk.js";
};